import { PanelStore } from '../interfaces';

export namespace PaymentLinkSelectors {
  export const getLoading = (state: PanelStore.RootState) => {
    return state.paymentLink.loading;
  };
  export const getError = (state: PanelStore.RootState) => {
    return state.paymentLink.error;
  };
  export const getErrorInfo = (state: PanelStore.RootState) => {
    return state.paymentLink.errorInfo;
  };
  export const getErrorFields = (state: PanelStore.RootState) => {
    return state.paymentLink.errorFields;
  };
  export const getCreateSuccess = (state: PanelStore.RootState) => {
    return state.paymentLink.createSuccess;
  };
  export const getShowResult = (state: PanelStore.RootState) => {
    return state.paymentLink.showResult;
  };
  export const getCurrencies = (state: PanelStore.RootState) => {
    return state.paymentLink.currencies;
  };
  export const getDocumentTypes = (state: PanelStore.RootState) => {
    return state.paymentLink.documentTypes;
  };
  export const getCreatedPaymentLinks = (state: PanelStore.RootState) => {
    return state.paymentLink.created;
  };
  export const getExistingClients = (state: PanelStore.RootState) => {
    return state.paymentLink.existingClients;
  };
}
